import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-logo">
          <img src={`${process.env.PUBLIC_URL}/assets/logo-lawsutra.svg`} alt="Lawsutra Logo" height={75} width={180} />
        </div>
        <div className="footer-links">
          <a href="/">Home</a>
          <a href="/features">Products</a>
          <a href="/process">Why Us</a>
          <a href="/insights">Insights</a>
          <a href="/contact">Contact</a>
        </div>
        <div className="social-links">
          <a href="https://facebook.com/lawsutra" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="https://twitter.com/lawsutra" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://linkedin.com/company/lawsutra" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 